import React from 'react'

import styles from "./upgrade.module.css";
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = ({ show, setShow }) => {
    const navigate = useNavigate();
    return (
        <>
            <Modal
                centered
                className={styles.UpgradeModal}
                show={show}
                onHide={() => setShow(false)}
                style={{
                    marginLeft: "-3px"
                }}
            >
                <Modal.Body className={styles.UpgradeModalBody}>
                    <div className={styles.UpgradeModalContainer}>
                        <div className={styles.UpgradeModalContent}>
                            <button
                                onClick={() => setShow(false)}
                                className={styles.UpgradeModalCloseButton}
                            >
                                &times;
                            </button>
                            <p className={styles.UpgradeModalTitle}>
                                Upgrade to Premium & Unlock Exclusive Features
                            </p>
                            <div className={styles.likebox}>
                                <p className={styles.UpgradeModalDescription}>
                                    As a Premium member, you can send unlimited messages, see who liked you, view all matches, access special events, and much more!
                                </p>
                                <div className={styles.UpgradeModalButtonContainer}>
                                    <div className={styles.UpgradeModalButtonWrapper}>
                                        <button
                                            className={`global-next-btn ${styles.UpgradeModalButton}`}
                                            onClick={() => navigate("/selectplan")}
                                        >
                                            Upgrade Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default UpgradeModal